export const validateEmail = (e) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(e).toLowerCase());
};

export const validateMobile = (e, maxNum = 11) => {
  if (isNaN(e)) {
    return false;
  }

  if (e.length !== maxNum) {
    return false;
  }

  return true;
};

export const validateAccount = (e) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (re.test(String(e).toLowerCase())) {
    return "email";
  } else {
    if (isNaN(e)) {
      return "username";
    }

    if (e.length === 10) {
      if (e[0] === "9") {
        return "mobile_num";
      } else {
        return "username";
      }
    } else if (e.length === 11) {
      if (`${e[0]}${e[1]}` === "09") {
        return "mobile_num";
      } else {
        return "username";
      }
    } else {
      return "username";
    }
  }
};

export const validatePassword = (e) => {
  let lowerCaseLetters = /[a-z]/g;
  let upperCaseLetters = /[A-Z]/g;
  let numbers = /[0-9]/g;
  let specialChar = /^[A-Za-z0-9 ]+$/;
  let countWValidator = 1;
  let countSValidator = 5;

  if (e.length >= 6) {
    countWValidator -= 1;
  }

  if (e.match(lowerCaseLetters)) {
    countSValidator -= 1;
  }

  if (e.match(upperCaseLetters)) {
    countSValidator -= 1;
  }

  if (e.match(numbers)) {
    countSValidator -= 1;
  }

  if (e.length >= 8) {
    countSValidator -= 1;
  }

  if (!specialChar.test(e)) {
    countSValidator -= 1;
  }

  return {
    wvalidator: countWValidator,
    svalidator: countSValidator,
  };
};

export const ValidateInt = (e) => {
  if (e.key !== "Backspace" && e.key !== "Tab" && e.key !== ".") {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  }
};

export const ParsingAmount = (val) => {
  return parseFloat(val).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
// PARSE AMOUNT TO ALWAYS ROUND UP
export const ParsingAmount2 = (val) => {
	const num = Number(val);
	if (isNaN(num)) return "0.00";
	const rounded = Math.ceil(num * 100) / 100;
	return rounded.toLocaleString('en-PH', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
};

export const ReverseParsingAmount = (val) => {
  if (val === null || val === undefined || val === "") return 0;

  // Remove all non-numeric characters except dot and minus sign
  const cleaned = val.toString().replace(/[^\d.-]/g, "");

  return parseFloat(cleaned) || 0;
};

export const ValidUrl = (url) => {
  // Function to validate if the URL is properly formatted for src link
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
};

export const validateTextKey = (e) => {
  const allowed = /^[A-Za-z\s]$/;
  if (!allowed.test(e.key) && e.key.length === 1) {
    e.preventDefault();
  }
};
// put this onPaste
export const handlePaste = (e) => {
  e.preventDefault();
};
// validate if the encodedString is valid to use window.atob
export const validateBase64String = (encodedString) => {
  try {
    window.atob(encodedString);
    return true;
  } catch (e) {
    return false;
  }
};

export const validateContactInformationStep = (form) => {
  const errors = {};
  if (form.existingClient && !form.selectedClient) {
    errors.selectedClient = "Client selection is required";
  }

  if (!form.contactName || !form.contactName.trim())
    errors.contactName = "Contact name is required";

  if (!form.position || !form.position.trim())
    errors.position = "Position is required";

  if (!form.contactNumber || !form.contactNumber.trim()) {
    errors.contactNumber = "Contact number is required";
  } else {
    const digitsOnly = form.contactNumber.replace(/[\s\-\+]/g, "");
    if (!validateMobile(digitsOnly)) {
      errors.contactNumber = "Invalid contact number (e.g. 09123456789)";
    }
  }

  if (!form.emailAddress || !form.emailAddress.trim()) {
    errors.emailAddress = "Email address is required";
  } else if (!validateEmail(form.emailAddress)) {
    errors.emailAddress = "Invalid email address";
  }

  if (!form.address || !form.address.trim())
    errors.address = "Address is required";

  if (!form.source || !form.source.trim()) errors.source = "Source is required";

  return errors;
};

export const validateCompanyBusinessDetailsStep = (form) => {
  const errors = {};
  if (form.forReferral && !form.referTo) {
    errors.referTo = "Employee selection is required";
  }
  if (!form.registeredName || !form.registeredName.trim())
    errors.registeredName = "Registered name is required";
  if (!form.industry || !form.industry.trim())
    errors.industry = "Industry is required";
  if (!form.legalStatus || !form.legalStatus.trim())
    errors.legalStatus = "Legal status is required";
  if (
    form.legalStatus === "Other" &&
    (!form.othersSpecify || !form.othersSpecify.trim())
  )
    errors.othersSpecify = "Please specify legal status";
  if (!form.companyAddress || !form.companyAddress.trim())
    errors.companyAddress = "Company address is required";
  if (!form.addresseeOnProposals || !form.addresseeOnProposals.trim())
    errors.addresseeOnProposals = "Addressee on proposals is required";
  if (!form.proposalPosition || !form.proposalPosition.trim())
    errors.proposalPosition = "Proposal position is required";
  return errors;
};

export const validateEngagementDetailsStep = (form) => {
  const errors = {};
  if (
    !form.engagements ||
    !Array.isArray(form.engagements) ||
    form.engagements.length === 0
  ) {
    errors.engagements = "At least one engagement is required";
    return errors;
  }
  errors.engagements = [];
  form.engagements.forEach((eng, idx) => {
    const engErr = {};
    if (!eng.engagementType || !eng.engagementType.trim())
      engErr.engagementType = "Engagement type is required";
    if (!eng.reportingPeriod || !eng.reportingPeriod.trim())
      engErr.reportingPeriod = "Reporting period is required";
    if (!eng.endDate || !eng.endDate.trim())
      engErr.endDate = "Ending date is required";
    if (!eng.coverageFrom || !eng.coverageFrom.trim())
      engErr.coverageFrom = "Coverage from date is required";
    if (!eng.coverageTo || !eng.coverageTo.trim())
      engErr.coverageTo = "Coverage to date is required";
    errors.engagements[idx] = engErr;
  });
  return errors;
};

export const validateLogActivityForm = (form) => {
  const errors = {};

  if (!form.communicationType || !form.communicationType.trim()) {
    errors.communicationType = "Communication type is required";
  }

  if (!form.subject || !form.subject.trim()) {
    errors.subject = "Subject is required";
  }

  if (!form.description || !form.description.trim()) {
    errors.description = "Description is required";
  }

  return errors;
};

export const validateKYCCompanyInfoStep = (form) => {
  const errors = {};
  if (!form.fullName) errors.fullName = "Full name is required";
  if (!form.legalStatus) errors.legalStatus = "Legal status is required";
  if (!form.permanentAddress) errors.permanentAddress = "Permanent address is required";
  if (!form.businessAddress) errors.businessAddress = "Business address is required";
  if (!form.secRegistration) errors.secRegistration = "SEC Registration is required";
  if (!form.purposeOfTransaction?.length)
    errors.purposeOfTransaction = "At least one purpose is required";
  return errors;
};

export const hcrmSession = JSON.parse(localStorage.getItem('hcrm_session'))
